import React from 'react';
import { formatCurrency } from '../../lib/formatters';

// PFS's own contact, by company name (same rule as utils/pfs_contact.py on the backend).
const PFS_NAME_RE = /^\s*power\s+funding\s+solutions\s*$/i;
export const isPfsName = (name) => PFS_NAME_RE.test(name || '');

// ─── Wire-In Amount Preview ──────────────────────────────────────────────
export const WireInPreview = ({ role, ownershipPct, dealFinancials, managementFeePct = 0 }) => {
  const pct = ownershipPct / 100;
  const { funding_amount, origination_fee, broker_commission } = dealFinancials || {};
  const fundedShare = (funding_amount || 0) * pct;
  const origShare = (origination_fee || 0) * pct;
  const brokerShare = (broker_commission || 0) * pct;
  let wireIn = 0, lines = [];
  if (role === 'PARTNER') {
    wireIn = fundedShare - origShare;
    lines = [{ label: 'Funded share', value: fundedShare, op: '' }, { label: 'Origination fee share', value: origShare, op: '−' }];
  } else if (role === 'INVESTOR_FEE') {
    wireIn = fundedShare - origShare + brokerShare;
    lines = [{ label: 'Funded share', value: fundedShare, op: '' }, { label: 'Origination fee share', value: origShare, op: '−' }, { label: 'Broker commission share', value: brokerShare, op: '+' }];
  } else {
    wireIn = fundedShare + brokerShare;
    lines = [{ label: 'Funded share', value: fundedShare, op: '' }, { label: 'Broker commission share', value: brokerShare, op: '+' }];
  }
  // 09/29 (Josh): management fee (2% upcharge) is asked per syndicator, charged up front on its own line
  const mf = parseFloat(managementFeePct) || 0;
  if (mf > 0) { const mfAmt = fundedShare * mf / 100; wireIn += mfAmt; lines.push({ label: `Management fee ${mf}%`, value: mfAmt, op: '+' }); }
  return (
    <div className="rounded-lg border border-blue-200 bg-blue-50 p-3 text-sm space-y-1" data-testid="wire-in-preview">
      <p className="font-medium text-blue-800 text-xs">Wire-In Preview</p>
      {lines.map((l, i) => (
        <div key={i} className="flex justify-between text-blue-700"><span>{l.op} {l.label}</span><span className="font-mono">{formatCurrency(l.value)}</span></div>
      ))}
      <div className="flex justify-between pt-1 border-t border-blue-200 font-bold text-blue-900"><span>Wire-In Amount</span><span className="font-mono">{formatCurrency(wireIn)}</span></div>
    </div>
  );
};

